module.exports = __webpack_public_path__ + "img/BKCY2.874c8e50.jpg";